module.exports = __webpack_public_path__ + "img/appleIcon.ed6d01ac.svg";